import { createContext } from "react";
import { Content } from "../types";

const ContentContext = createContext<null|Content>(null);

export default ContentContext;